import axios from "../plugins/axios.plugin";

class WalletService {
  baseServicePath = "/api/wallet";

  storeWallet(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }

  getAllWallets() {
    return axios.get(`${this.baseServicePath}/index?properties=1`);
  }
  searchInvites(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }
  filterInvites(payload) {
    return axios.post(`${this.baseServicePath}/filter/index`, payload);
  }
  deleteWallet(payload) {
    return axios.post(`${this.baseServicePath}/delete`, payload);
  }

  editInvite(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }
  showWallet(payload) {
    return axios.post(
      `${this.baseServicePath}/show?user_id=${payload}&properties=1`,
      payload
    );
  }
  showMyWallets() {
    return axios.get(`${this.baseServicePath}/me?properties=1`);
  }
  RefuseInvite(payload) {
    return axios.post(`${this.baseServicePath}/refuse`, payload);
  }
}

export const walletService = new WalletService();
